<template>
  <div class="blacklist-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong class="first"><h3>{{$t('blacklist')}}</h3></strong>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="pb-15">
        <b-col cols="12">
          <b-card class="header mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('blacklist.basic_information') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus" v-b-toggle.basic_information_content>
                <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row">
                <b-col cols="12">
                  <b-form-group class="col-sm-6" v-bind:label="$t('blacklist.email')" :label-cols="2" :horizontal="true" >
                    <b-form-input
                      class="form-control border-radius-4px"
                      v-model="item.email"
                      :state="!$v.item.email.$invalid"
                      :aria-describedby="'email-feedback'"
                    />
                    <b-form-invalid-feedback :id="'email-feedback'">
                      {{ $t('message.required_filed') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group class="col-sm-6" v-bind:label="$t('blacklist.phone')" :label-cols="2" :horizontal="true" >
                    <b-form-input
                      class="form-control border-radius-4px"
                      v-model="item.phone"
                      :state="!$v.item.phone.$invalid"
                      :aria-describedby="'phone-feedback'"
                    />
                    <b-form-invalid-feedback :id="'phone-feedback'">
                      {{ $t('message.required_filed') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-form>
            </b-collapse>
            <div slot="footer">
              <div>
                <button type="button" class="btn border-radius-4px bg-main float-left" @click="$router.push({name: 'blacklist'})"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
              </div>
              <div class="btn-save">
                <button type="button" class=" pull-right btn bg-main border-radius-4px pl-3 pr-3" v-on:click="saveBlacklist()" :disabled="checkSubmit() "> {{$t('common.save')}}</button>
              </div>
             </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import { required, requiredIf, email } from 'vuelidate/lib/validators'
  import { validationMixin } from "vuelidate";

  let vm = null
  export default {
    name: 'BlacklistForm',
    props: {
      uuid: {
        type: String,
        required: true,
        default: 'create'
      }
    },
    components: {
    },
    data: function () {
      return {
        basicInformationStatus: true,
        item: {
          email: '',
          phone: ''
        }
      }
    },
    mixins: [
      validationMixin
    ],
    computed: {
      rules() {
        return {
          email: {
            required: requiredIf(function (nestedModel) {
              return this.item.phone === ''
            }),
            email
          },
          phone: {
            required: requiredIf(function (nestedModel) {
              return this.item.email === ''
            }),
          }
        }
      }
    },
    validations() {
      return {
        item: this.rules
      }
    },
    methods: {
      checkSubmit: function () {
        return vm.$v.item.$invalid
      },
      saveBlacklist () {
        var data = JSON.parse(JSON.stringify(vm.item))
        vm.axios.order.createBlacklist(data, function (response) {
          vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
          vm.$router.push({name: 'blacklist_list'})
        }, function () {
        })
      },
      /**
       * update status of customise session
       */
      updateBasicInformationStatus () {
        this.basicInformationStatus = !this.basicInformationStatus
      },
    },
    created: function () {
      vm = this
    },
  }
</script>

<style scoped>

  .back-button {
    padding-left: 25px;
    width: 95px;
    float: left;
  }

  .blacklist-form .btn-save{
    float: right !important;
    padding-right: 22px;
    margin-right: 0px !important;
    box-sizing: border-box;
    text-align: right;
  }
  /*END Form Wizard*/
</style>

<style>
  .blacklist-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .blacklist-form div.header,
  .blacklist-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .close-btn .fa-angle-right {
    margin-right: -4px;
  }
  .close-btn .fa-angle-left {
    margin-left: -4px;
  }
  .blacklist-form .btn-primary .fa{
    font-size: 20px;
  }
  .blacklist-form .btn-primary {
    color: #0091ff;
    background-color: transparent;
  }
  .blacklist-form .btn-primary:hover{
    color: #0091ff;
    background-color: transparent;
  }
  .pt-05{
    padding: 0.5rem;
  }
  .pb-15{
    padding-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/blacklist/Form.vue